import React, { Component, Fragment } from 'react';
import {
  View,
  TouchableOpacity,
  Image,
  SafeAreaView,
  Text,
  KeyboardAvoidingView,
  Keyboard,
  ActivityIndicator,
  TouchableWithoutFeedback,
} from 'react-native';
import StyleSheet from 'react-native-media-query';
import { PopUpStyles } from './styles';
import images from '../../theme/Images';
import { withEither } from '../../lib/Monads';
import Utility from '../../utils/Utility';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { editProfile } from '../../actions/ActionTypes';
import { TextField } from 'react-native-material-textfield';
import colors from '../../theme/Colors';
import { AnalyticsManager, EventParameterKey } from '../../analytics';
import { isDesktop } from '../../utils/BooleanUtility';

class AddEmailModal extends Component {
  addEmailModalConstants = {
    invalidEmail: 'Email address is invalid',
  };

  state = {
    email: '',
    isEmailValid: true,
    showLoader: false,
  };

  addEmail = (value) => {
    const isValid = value.includes('.') ? Utility.validateEmail(value) : true;
    this.setState({
      email: value,
      isEmailValid: isValid,
    });
  };

  emailInput = () => {
    const { email, isEmailValid } = this.state;
    return (
      <View style={PopUpStyles.addEmailContainer}>
        <TextField
          style={PopUpStyles.textInputStyleForEmail}
          label="Email"
          placeholder="Enter your email"
          onChangeText={this.addEmail}
          value={email}
          autoFocus={true}
          autoCapitalize={false}
          hideLabel={false}
          inputContainerStyle={{ borderBottomColor: colors.border }}
          error={
            !isEmailValid ? this.addEmailModalConstants.invalidEmail : null
          }
          tintColor={colors.silver}
        />
      </View>
    );
  };

  cancelpressed = () => {
    const { navigation } = this.props;
    Keyboard.dismiss();
    navigation.goBack();
  };

  continuePressed = () => {
    const { email } = this.state;
    const { editProfile, furtherAction, skuId, stocked_status } = this.props;
    AnalyticsManager.logEvent(EventParameterKey.ITEM_ACTION_NEW, {
      [EventParameterKey.TYPE]: 'email_submit',
      [EventParameterKey.SKU_ID]: skuId,
      [EventParameterKey.EMAIL_PRESENT]: Utility.isPresent(email),
      [EventParameterKey.STOCKED_STATUS]: stocked_status,
    });
    const isValid = Utility.validateEmail(email);
    if (!isValid) {
      this.setState({
        isEmailValid: isValid,
      });
      return;
    }
    const user = {};
    user.email = email;
    Keyboard.dismiss();
    this.setState({
      showLoader: true,
    });
    editProfile(user, {}, (callbackData, success) => {
      if (success) {
        this.cancelpressed();
        setTimeout(() => {
          if (furtherAction) {
            furtherAction();
          }
          this.setState({
            showLoader: false,
          });
        }, 1000);
      } else {
        this.cancelpressed();
      }
    });
  };

  isIosFn = () => Utility.isIOS();

  customKeyboardAvoid = withEither(this.isIosFn, KeyboardAvoidingView)(isDesktop() ? Fragment : View);

  render() {
    const submitText = 'Save';
    const reviewText = 'Add Email';
    return (
      <>
        <TouchableWithoutFeedback onPress={this.cancelpressed}>
          <View style={styles.touchableContainer} />
        </TouchableWithoutFeedback>
        <this.customKeyboardAvoid
          behavior='position'
          enabled
          keyboardVerticalOffset={-18}
        >
          <View style={styles.container} pointerEvents='box-none' dataSet={{ media: ids.container }}>
            <View style={PopUpStyles.addReviewHeader}>
              <Text style={PopUpStyles.reviewHeaderText}>{reviewText}</Text>
              <TouchableOpacity
                style={PopUpStyles.cancelButton}
                onPress={this.cancelpressed}
              >
                <Image source={images.cross} style={PopUpStyles.cancelStyle} />
              </TouchableOpacity>
            </View>
            <this.emailInput />
            <TouchableOpacity
              style={PopUpStyles.submitButtonWithBottomInset}
              onPress={this.continuePressed}
            >
              <ActivityIndicator
                style={PopUpStyles.activityIndicatorInActionButton}
                animating={this.state.showLoader}
                color={colors.white}
              />
              <Text style={PopUpStyles.submitText}>{submitText}</Text>
            </TouchableOpacity>
          </View>
        </this.customKeyboardAvoid>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({ editProfile }, dispatch),
});

export default connect(null, mapDispatchToProps)(AddEmailModal);

const { ids, styles } = StyleSheet.create({
  touchableContainer: {
    height: '100%',
    width: '100%',
    backgroundColor: colors.translucent,
  },
  container: {
    flexDirection: 'column',
    backgroundColor: colors.white,
    width: Utility.getScreenWidth(),
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    position: 'absolute',
    bottom: 0,
    '@media (min-width: 768px)': {
      width: Utility.getScreenWidth() / 2,
      bottom: '50%',
      left: '50%',
      transform: 'translate(-50%, 50%)',
    },
  },
});
